export const canvasAttentionCursor = `url(/assets/cursors/attention.svg) 9 8, crosshair`;
export const canvasCommentCursor = `url(/assets/cursors/chat-cloud.svg) 0 0, copy`;
export const canvasPenCursor = `url(/assets/cursors/pen.svg) 0 18, crosshair`;
export const canvasStickyNoteCursor = `url(/assets/cursors/sticky.svg) 0 0, crosshair`;
